import {
    FaceTecCancelButtonCustomization,
    FaceTecCustomization,
    FaceTecFeedbackBarCustomization,
    FaceTecFrameCustomization,
    FaceTecGuidanceCustomization,
    FaceTecInitialLoadingAnimationCustomization,
    FaceTecOvalCustomization,
    FaceTecOverlayCustomization,
    FaceTecResultScreenCustomization,
    FaceTecVocalGuidanceCustomization,
} from '../../../../assets/facetec/core-sdk/FaceTecSDK.js/FaceTecCustomization';
import {FaceTecFaceScanResultCallback, FaceTecSessionResult} from '../../../../assets/facetec/core-sdk/FaceTecSDK.js/FaceTecPublicApi';

export const FACE_TEC_SDK_SCRIPT = 'assets/facetec/core-sdk/FaceTecSDK.js/FaceTecSDK.js';
export const FACE_TEC_SDK_RESOURCES = 'assets/facetec/core-sdk/FaceTecSDK.js/v9_7_129';
export const FACE_TEC_SDK_IMAGES = 'assets/facetec/core-sdk/FaceTec_images';

export function facetecCustomization(locale: string): any {
    const FaceTecSDK = (window as any).FaceTecSDK;
    const backgroundColor = '#FFFFFF';
    const textColor = '#000000';
    const buttonTextColor = '#FFFFFF';
    const feedbackBarBackground = 'rgba(255,255,255,0.7)';
    const overlay: FaceTecOverlayCustomization = new FaceTecSDK.FaceTecOverlayCustomization();
    overlay.backgroundColor = 'rgba(33,36,33,0.8)';
    overlay.showBrandingImage = false;

    const frame: FaceTecFrameCustomization = new FaceTecSDK.FaceTecFrameCustomization();
    frame.backgroundColor = backgroundColor;
    frame.borderCornerRadius = '20px';
    frame.borderColor = backgroundColor;
    frame.borderWidth = '2px';

    const feedbackBar: FaceTecFeedbackBarCustomization = new FaceTecSDK.FaceTecFeedbackBarCustomization();
    feedbackBar.backgroundColor = feedbackBarBackground;
    feedbackBar.shadow = 'none';
    feedbackBar.enablePulsatingText = false;
    feedbackBar.cornerRadius = '4px';
    feedbackBar.textColor = textColor;
    feedbackBar.textFont = 'Helvetica';

    const oval: FaceTecOvalCustomization = new FaceTecSDK.FaceTecOvalCustomization();
    oval.strokeColor = '#045B4A';
    oval.strokeWidth = 10;
    oval.progressColor1 = 'rgba(255,255,255,0.7)';
    oval.progressColor2 = 'rgba(255,255,255,0.8)';
    oval.progressStrokeWidth = 10;

    const guidanceCustomization: FaceTecGuidanceCustomization = new FaceTecSDK.FaceTecGuidanceCustomization();
    guidanceCustomization.backgroundColors = backgroundColor;
    guidanceCustomization.foregroundColor = textColor;

    guidanceCustomization.headerFont = 'Helvetica';
    guidanceCustomization.subtextFont = 'Helvetica';

    guidanceCustomization.buttonBackgroundNormalColor = '#045B4A';
    guidanceCustomization.buttonBackgroundHighlightColor = '#034538';
    guidanceCustomization.buttonBackgroundDisabledColor = '#F0F0F0';
    guidanceCustomization.buttonTextNormalColor = buttonTextColor;
    guidanceCustomization.buttonTextDisabledColor = '#CACACA';
    guidanceCustomization.buttonBorderWidth = '0';
    guidanceCustomization.buttonFont = 'Helvetica';
    guidanceCustomization.buttonCornerRadius = '4px';

    guidanceCustomization.readyScreenOvalFillColor = 'transparent';
    guidanceCustomization.readyScreenTextBackgroundColor = '#045B4A';
    guidanceCustomization.readyScreenTextBackgroundCornerRadius = '4px';
    guidanceCustomization.readyScreenHeaderTextColor = textColor;
    guidanceCustomization.readyScreenHeaderFont = 'Helvetica';
    guidanceCustomization.readyScreenSubtextFont = 'Helvetica';
    guidanceCustomization.readyScreenSubtextTextColor = textColor;

    guidanceCustomization.retryScreenImageBorderWidth = '0';
    guidanceCustomization.retryScreenHeaderTextColor = textColor;
    guidanceCustomization.retryScreenSubtextTextColor = textColor;
    guidanceCustomization.retryScreenHeaderFont = 'Helvetica';
    guidanceCustomization.retryScreenSubtextFont = 'Helvetica';
    guidanceCustomization.retryScreenOvalStrokeColor = '#045B4A';

    const result: FaceTecResultScreenCustomization = new FaceTecSDK.FaceTecResultScreenCustomization();
    result.backgroundColors = backgroundColor;
    result.foregroundColor = textColor;
    result.activityIndicatorColor = '#5DAA5C';
    result.uploadProgressFillColor = '#5DAA5C';
    result.uploadProgressTrackColor = '#F0F0F0';
    result.resultAnimationBackgroundColor = '#045B4A';
    result.resultAnimationForegroundColor = '#FFFFFF';

    const customization: FaceTecCustomization = new FaceTecSDK.FaceTecCustomization();
    customization.overlayCustomization = overlay;
    customization.frameCustomization = frame;
    customization.feedbackCustomization = feedbackBar;
    customization.initialLoadingAnimationCustomization = {
        foregroundColor: '#5DAA5C',
        messageTextColor: '#5DAA5C'
    } as FaceTecInitialLoadingAnimationCustomization;
    customization.guidanceCustomization = guidanceCustomization;
    customization.ovalCustomization = oval;
    customization.resultScreenCustomization = result;
    customization.enableCameraPermissionsHelpScreen = false;
    customization.cancelButtonCustomization = {location: 2} as FaceTecCancelButtonCustomization;
    customization.vocalGuidanceCustomization = {mode: vocalCustomization(locale)} as FaceTecVocalGuidanceCustomization;
    return customization;
}

export function faceTecLowLightCustomization(locale: string): any {
    const defaultCustomization = facetecCustomization(locale);

    defaultCustomization.overlayCustomization.backgroundColor = 'rgba(255,255,255,0.8)';
    defaultCustomization.frameCustomization.borderColor = '#212421';
    return defaultCustomization;
}

export function faceTecDynamicDimmingCustomization(locale: string): any {
    const defaultCustomization = facetecCustomization(locale);
    defaultCustomization.frameCustomization.backgroundColor = '#212421';
    defaultCustomization.overlayCustomization.backgroundColor = 'rgba(33,36,33,0.8)';
    defaultCustomization.guidanceCustomization.backgroundColors = '#212421';
    defaultCustomization.guidanceCustomization.foregroundColor = '#FFFFFF';
    defaultCustomization.guidanceCustomization.readyScreenHeaderTextColor = '#FFFFFF';
    defaultCustomization.guidanceCustomization.readyScreenSubtextTextColor = '#FFFFFF';
    defaultCustomization.guidanceCustomization.retryScreenHeaderTextColor = '#FFFFFF';
    defaultCustomization.guidanceCustomization.retryScreenSubtextTextColor = '#FFFFFF';
    return defaultCustomization;
}

function vocalCustomization(locale: string): number {
    if (locale === 'en') {
        return 0;
    } else {
        return 2;
    }
}

export type FaceTecModuleSessionResult = FaceTecSessionResult;
export type FaceTecModuleFaceScanResultCallback = FaceTecFaceScanResultCallback;

export type LivenessCallback =
    (sessionResult: FaceTecModuleSessionResult, faceScanResultCallback: FaceTecModuleFaceScanResultCallback) => void;

export enum FaceTecZoomState {
    STARTED = 'STARTED',
    CLOSED = 'CLOSED',
    COULD_NOT_BE_LOADED = 'COULD_NOT_BE_LOADED',
    CAMERA_NOT_FOUND = 'CAMERA_NOT_FOUND',
    CANCELLED_BY_USER = 'CANCELLED_BY_USER',
    CANCELLED_BY_FACE_TEC = 'CANCELLED_BY_FACE_TEC',
    NETWORK_ERROR = 'NETWORK_ERROR',
    ORIENTATION_ERROR = 'ORIENTATION_ERROR',
    UNKNOWN = 'UNKNOWN',
    DEVICE_NOT_SUPPORTED = 'DEVICE_NOT_SUPPORTED',
    SUCCEED = 'SUCCEED',
    LIVENESS_FAILED = 'LIVENESS_FAILED',
    FACE_NOT_MATCHED = 'FACE_NOT_MATCHED',
    LIMIT_PER_SESSION_EXCEEDED = 'LIMIT_PER_SESSION_EXCEEDED'
}

export interface Resource {
    name: string;
    status?: 'success' | 'error';
    error?: any;
    progress?: number;
}

export interface FaceTecResult {
    status: FaceTecZoomState;
    requestId?: string;
    rootStatus: string;
    errorSource?: string;
}
